import CloseIcon from "../../images/icon_close.svg";
import { getHHMM } from "../../utils/dates";
import { dateToRegularFormat } from "../../utils/dates";
import { formatNumber } from "../../utils/numbers";
import Sidebar from "../Sidebar/Sidebar";
import { AppointmentConvert } from "../VctTicketsAdmin/VctTickets.interface";
import {
  AppointmentInfo,
  BoldText,
  CloseButton,
  Container,
  DetailInfo,
  DispatcherInfo,
  SectionTitle,
  StatusDiv,
  Text,
  VehicleCard,
  VehicleRow,
  VehiclesInfo,
  VolanteCard,
  VolantesInfo,
} from "./VctTicketSidebarStyles";

interface Props {
  onOutsideClick: () => void;
  appointment: AppointmentConvert;
}

function VctTicketSidebar(props: Props) {
  const { appointment, onOutsideClick } = props;

  let parcelsNum = 0;

  appointment.volantes.forEach((volante) => {
    parcelsNum += Number(volante.parcels_num);
  });

  return (
    <Sidebar onOutsideClick={onOutsideClick}>
      <Container>
        <DispatcherInfo>
          <p className="dispatcher-id">{`DNI: ${appointment.dispatcherDocumentNumber}`}</p>
          <CloseButton onClick={onOutsideClick}>
            <img src={CloseIcon} alt="Cerrar" />
          </CloseButton>
          <p className="dispatcher-name">{appointment.dispatcherName}</p>
          <StatusDiv status={appointment.appointmentStatus.category}>
            <span>{appointment.appointmentStatus.label.toUpperCase()}</span>
          </StatusDiv>
        </DispatcherInfo>
        <AppointmentInfo>
          <DetailInfo>
            <div>
              <div>
                <p className="info-label">GRUPOS</p>
                <p className="info-text">{appointment.groupsNum}</p>
              </div>
              <div>
                <p className="info-label">BULTOS</p>
                <p className="info-text">{parcelsNum}</p>
              </div>
              <div>
                <p className="info-label">HORA DE RETIRO</p>
                <p className="info-text">
                  {getHHMM(appointment.timeslot.start)} A{" "}
                  {getHHMM(appointment.timeslot.end)}
                </p>
              </div>
              <div>
                <p className="info-label">NÚMERO DE VCT</p>
                <p className="info-text">{appointment.vctId || "-"}</p>
              </div>
            </div>
            <div>
              <div>
                <p className="info-label">PESO</p>
                <p className="info-text">{`${formatNumber(
                  appointment.parcelsWeight
                )} kg`}</p>
              </div>
              <div>
                <p className="info-label">SEGMENTO</p>
                <p className="info-text">
                  {appointment.segmentCategory.label
                    ? appointment.segmentCategory.label
                    : "-"}
                </p>
              </div>
              <div>
                <p className="info-label">FECHA</p>
                <p className="info-text">
                  {dateToRegularFormat(appointment.withdrawalDate)}
                </p>
              </div>
              <div>
                <p className="info-label">COD. DIQUE</p>
                <p className="info-text">{appointment.dockNum || "-"}</p>
              </div>
            </div>
          </DetailInfo>
          <VolantesInfo>
            <h1>{`Volantes (${appointment.volantes.length})`}</h1>
            {appointment.volantes.map((volante, index) => {
              return (
                <VolanteCard key={index}>
                  <div className="volante-detail">
                    <BoldText>{volante.volante_num}</BoldText>
                  </div>
                  <div className="volante-detail">
                    <SectionTitle>GUÍA MADRE</SectionTitle>
                    <Text>{volante.master_air_waybill}</Text>
                  </div>
                  <div className="volante-detail">
                    <SectionTitle>GUÍA HIJA</SectionTitle>
                    <Text>{volante.house_air_waybill}</Text>
                  </div>
                </VolanteCard>
              );
            })}
          </VolantesInfo>
          <VehiclesInfo>
            <h1>{`Vehículos (${appointment.vehicles.length})`}</h1>
            {appointment.vehicles.map((vehicle, index) => {
              return (
                <VehicleCard key={index}>
                  <VehicleRow>
                    <div>
                      <p className="vehicle-label">TIPO DE VEHÍCULO</p>
                      <p>{vehicle.vehicle_category.label}</p>
                    </div>
                    <div>
                      <p className="vehicle-label">PLACA</p>
                      <p>{vehicle.plate}</p>
                    </div>
                  </VehicleRow>
                  <VehicleRow>
                    <div>
                      <p className="vehicle-label">DNI</p>
                      <p>{vehicle.driver.document_number}</p>
                    </div>
                    <div>
                      <p className="vehicle-label">BREVETE</p>
                      <p>{vehicle.driver.brevete}</p>
                    </div>
                  </VehicleRow>
                  <div className="driver-name-container">
                    <p className="vehicle-label">TRANSPORTISTA</p>
                    <p>{vehicle.driver.name}</p>
                  </div>
                </VehicleCard>
              );
            })}
          </VehiclesInfo>
        </AppointmentInfo>
      </Container>
    </Sidebar>
  );
}

export default VctTicketSidebar;
